<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-searchbar
      #searchBank
      chape="round"
      placeholder="Encuentra tu banco"
      inputmode="text"
      type="text"
      (ionInput)="onSearchChange($event)"
      [debounce]="250"
      showCancelButton="never"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    @for(bank of banks | search: searchTerm | slice: 0 : items; track bank.Code){
    <ion-item button (click)="send(bank)" detail>
      <ion-icon slot="start" name="business-outline"></ion-icon>
      <ion-label>{{ bank.Bank }}</ion-label>
    </ion-item>
    }
  </ion-list>
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
